define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            cookieTimeout: 60 * 60 * 24 * 30,
            buttonSelector: '.js-chooseRegionSelector',
            dropdownSelector: '.js-regionSelector',
            closeButtonSelector: '.js-closeRegionSelector',
            triggerOnDropdownChange: false,
            ignoreFirstItem: true,
            regionPickerSelector: null
        },

        init: function () {
            const self = this;

            self.dropdown = self.el.querySelector(self.options.dropdownSelector);
            self.closeButton = self.el.querySelector(self.options.closeButtonSelector);

            if (self.options.regionPickerSelector != null) {
                let newTabDispatcher = function (url) {
                    // Open in a new tab
                    const newTab = window.open(url, '_blank');
                    if (newTab) {
                        newTab.focus();
                    } else {
                        console.warn('Failed to open new tab. Please allow pop-ups for this site.');
                    }
                };
                self.el.addEventListener('click', function (e) {
                    if (e.target.matches(self.options.regionPickerSelector)) {
                        let dispatcher = null;
                        if (e.ctrlKey || e.shiftKey) {
                            dispatcher = newTabDispatcher
                        }
                        self.setCookieAndFetchGo(e.target, dispatcher);
                        e.preventDefault();
                    }
                });
                self.el.addEventListener('auxclick', function (e) {
                    if (e.button === 1 && e.target.matches(self.options.regionPickerSelector)) { // Middle mouse button
                        self.setCookieAndFetchGo(e.target, newTabDispatcher);
                        e.preventDefault();
                    }
                });
                self.el.addEventListener('mousedown', function (e) { // hack-ish way to prime the right click-menu
                    if (e.button == 2 && e.target.matches(self.options.regionPickerSelector) && e.target.attributes['href'].value == '#') {
                        self.fetchGo(e.target, function (url) {
                            e.target.href = url;
                        });
                    }
                });
            }

            var button = self.el.querySelector(self.options.buttonSelector);
            if (button) {
                button.addEventListener('click', function (e) {
                    self.triggerChange(self);
                });
                button.addEventListener('auxclick', function (e) {
                    if (e.button === 1) { // Middle mouse button)
                        self.triggerChange(self, function (url) {
                            // Open in a new tab
                            const newTab = window.open(url, '_blank');
                            if (newTab) {
                                newTab.focus();
                            } else {
                                console.warn('Failed to open new tab. Please allow pop-ups for this site.');
                            }
                        });
                    }
                });
            }

            if (self.dropdown && self.options.triggerOnDropdownChange) {
                self.dropdown.addEventListener('change', function (e) {
                    self.triggerChange(self);
                });
            }

            if (self.closeButton) {
                self.closeButton.addEventListener('keydown', function (e) {
                    if (e.key == 'Enter') {
                        e.target.dispatchEvent(new Event('click'));
                    }
                });
                self.closeButton.addEventListener('click', function (e) {
                    self.setCookie(this);
                    self.el.parentNode.removeChild(self.el);
                    return false;
                });
            }

            const params = window.location.search.split("?")[1];
            if (self.closeButton && params) {
                const paramsArr = params.split('&');
                for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
                    const parts = paramsArr[i].split("=");
                    if (parts[0] === 'setregion') {
                        self.setCookie(self.closeButton);
                        self.el.parentNode.removeChild(self.el);
                        break;
                    }
                }
            }
        },

        triggerChange: function (self) {
            if (self.options.ignoreFirstItem && self.dropdown.selectedIndex == 0) {
                return false;
            }
            const region = self.dropdown.options[self.dropdown.selectedIndex];
            self.setCookieAndFetchGo(region);
            return false;
        },

        setCookie: function(regionElement) {
            const self = this;
            const regionId = regionElement.getAttribute('data-region');
            self.setRegionCookie(regionId, self.options.cookieTimeout);
        },

        setCookieAndFetchGo: function (regionElement, action) {
            const self = this;
            const regionId = regionElement.getAttribute('data-region');
            const pageId = regionElement.getAttribute('data-page');
            const languageId = regionElement.getAttribute('data-language');
            self.setRegionCookie(regionId, self.options.cookieTimeout);
            if (pageId && languageId) {
                const formData = new FormData();
                formData.append('regionId', regionId);
                formData.append('currentPage', pageId);
                formData.append('language', languageId);
                fetch('/__api/getregionpageurl', { method: 'POST', body: formData }).then(response => {
                    if (response.status != 200) {
                        return;
                    }
                    response.text().then(text => {
                        if (action) {
                            action(text);
                        } else {
                            location.href = text;
                        }
                    });
                });
            }
        },

        setRegionCookie: function (regionId, expirationInSeconds) {
            let expires = "";
            if (expirationInSeconds > 0) {
                var d = new Date();
                d.setTime(d.getTime() + expirationInSeconds * 1000);
                expires = ";expires=" + d.toUTCString();
            }
            document.cookie = "region=" + regionId + expires + ';SameSite=Strict;path=/';
        }
    });
});